export function isStructureVulnerable(structure, previousStructures) {
  if (!structure.requires) return true;
  const reqIds = Array.isArray(structure.requires)
    ? structure.requires
    : [structure.requires];
  return reqIds.every(id => {
    const parent = previousStructures.find(s => s.id === id);
    return parent ? parent.isDead : true;
  });
}

/**
 * First living structure of team that may take damage (requires chain).
 * Layout order: outer → inhib turret → inhib → nexus turrets → nexus.
 * Inhib does not require nexus turrets.
 */
export function selectNextVulnerableStructure(structures, team) {
  const peers = structures || [];
  return peers.find((s) => (
    s
    && !s.isDead
    && s.team === team
    && isStructureVulnerable(s, peers)
  )) || null;
}

export function updateInhibitorState(inhibitor, gameTime) {
  if (!inhibitor.isDead) return inhibitor;

  const elapsed = gameTime - inhibitor.destroyedAt;
  if (elapsed >= inhibitor.respawnTimer) {
    return {
      ...inhibitor,
      isDead: false,
      hp: inhibitor.maxHp
    };
  }

  return inhibitor;
}
